module.exports = __webpack_public_path__ + "img/tunnel.0cd0ceb6.jpg";